import { defaultAxios, IParams } from './base';

export interface IFetchBaseCid extends IParams {
  challengeSeq?: string;
  appUserId: string,
  appUserPartIdx: string,
  mgntCd: string,
  passAppId: string,
  mediaCd: string
}

export const fetchChallengeEntry = (params: IFetchBaseCid) => {
  return defaultAxios().post(`/challenge/entry`, params);
};